import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

import { SanityGallerySection } from '../../../graphql/gatsby'
import { pageSectionStylesFor } from '../styles'

export const Container = styled.div<Pick<SanityGallerySection, 'pageSectionStyles'>>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.colors.grayscale.white};
  padding-left: 2.25rem;
  padding-right: 2.25rem;
  ${({ pageSectionStyles }) => pageSectionStylesFor(pageSectionStyles)};
  @media (min-width: 768px) {
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }
  @media (min-width: 992px) {
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }
`

export const Title = styled.h1`
  display: inline;
  color: ${({ theme }) => theme.colors.brand.blue};
  font-weight: 700;
  font-size: 36px;
  text-align: center;
`

export const Subtitle = styled.h2`
  display: inline;
  color: ${({ theme }) => theme.colors.brand.categoryTurquoise};
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  margin-bottom: 40px;
`

export const GalleryItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const GalleryCollectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 100px;

  &:first-of-type {
    margin-top: 44px;
  }
`

export const ItemsLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: start;

  @media (min-width: 992px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

export const ItemImage = styled(GatsbyImage)`
  grid-area: image;
  object-fit: contain;
  width: 100%;
  border-radius: 8px;
`

export const ItemTitle = styled.h3`
  font-weight: 700;
  font-size: 22px;
  margin: 0 0 16px;
`
export const ItemDescription = styled.p`
  margin: 0;
`
